import { axiosRequest } from "../axios.config";

const uploadAPI = {
  uploadImage: async (imageFile) => {
    const url = "UploadFile/UploadImage";
    const formDataImage = new FormData();
    formDataImage.append("image", imageFile);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    const response = await axiosRequest.post(url, formDataImage, config);
    console.log(response);
    return response;
  },
  uploadVideo: async (videoFile) => {
    const url = "UploadFile/UploadVideo";
    const formDataVideo = new FormData();
    formDataVideo.append("video", videoFile);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    const response = await axiosRequest.post(url, formDataVideo, config);
    return response;
  },
  uploadFile: async (file) => {
    const url = "UploadFile/Upload-File-Google-Drive";
    const formDataFile = new FormData();
    formDataFile.append("file", file);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    const response = await axiosRequest.post(url, formDataFile, config);
    const newRes = {
      ...response,
      url: `https://drive.google.com/file/d/${response.url}`,
    };
    console.log(newRes);
    return newRes;
  },
};

export { uploadAPI };
